module.exports = __webpack_public_path__ + "img/grg.363af0c9.svg";